import React from 'react';
import { Box } from '@mui/material';
import OrganizationsProviderDashboard from '../../components/administracion/proveedores/OrganizationsProviderDashboard';

const OrganizacionesProveedorPage = () => {

  return (
    <Box sx={{ p: 2 }}>
      <OrganizationsProviderDashboard
        onReorder={(newOrder) => {
          console.log('Nuevo orden de organizaciones proveedoras:', newOrder);
        }}
      />
    </Box>
  );
};

export default OrganizacionesProveedorPage;